// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/Cofre_ShowResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * Response contract for GET /cofre/show/:id.
 */
import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export interface Cofre_ShowResponseDados {
id?: number
franquia_id?: number
nome?: string
banco?: string
agencia?: string
conta?: string
tipo?: string
saldo_atual?: number
observacao?: string
created_at?: string
updated_at?: string
}

export type Cofre_ShowResponse = ApiResponse<Cofre_ShowResponseDados>;

registerResponseContract('Cofre_ShowResponse', {
  id:          { type: 'number',  required: false },
  franquia_id: { type: 'number',  required: false },
  nome:        { type: 'string',  required: false },
  banco:       { type: 'string',  required: false },
  agencia:     { type: 'string',  required: false },
  conta:       { type: 'string',  required: false },
  tipo:        { type: 'string',  required: false },
  saldo_atual: { type: 'number',  required: false },
  observacao:  { type: 'string',  required: false },
  created_at:  { type: 'string',  required: false },
  updated_at:  { type: 'string',  required: false },
})
